const initialState = {
  contact_information: {
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    social_security_number: "",
    street_address: "",
    zip_code: "",
    mailing_address: "",
    municipality: "",
    current_street_address: "",
    current_zip_code: "",
    current_mailing_address: "",
    confirmationEmail: true
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONFIRMATION_EMAIL_DATA":
      return Object.assign({}, state, {
        confirmationEmail: action.data
      })

    case "SET_CONTACT_DATA_SUCCESS":
      return {
        ...state,
        contact_information: Object.assign(
          {},
          state.contact_information,
          action.payload
        )
      };

    default:
      return state;
  }
};
